import Model, { attr } from '@warp-drive/legacy/model';
import type { Type } from '@warp-drive/core/types/symbols';

// Proto: attendance.LearnerRecords.
export default class RecordsByLearner extends Model {
  declare [Type]: 'attendance/records-by-learner';

  @attr('string', { defaultValue: '' })
  declare personId: string;

  // TS-STANDIN(proto attendance.Record): raw attr holds plain JSON.
  @attr()
  declare records: unknown;
}
